import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { authApi } from '../../api/client'
import toast from 'react-hot-toast'

export default function VerifyEmailPage() {
  const [params] = useSearchParams()
  const [email, setEmail] = useState(params.get('email') || '')
  const [code, setCode] = useState('')
  const navigate = useNavigate()

  const verifyMut = useMutation({
    mutationFn: () => authApi.verifyEmail(email, code),
    onSuccess: () => { toast.success('Email verified! You can now sign in.'); navigate('/login') },
    onError: (e: any) => toast.error(e.response?.data?.detail || 'Verification failed'),
  })

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="text-5xl mb-4">📧</div>
          <h1 className="text-2xl font-extrabold">Verify your email</h1>
          <p className="text-brand-muted text-sm mt-2">Enter the 6-digit code we sent to your email address</p>
        </div>
        <form className="card space-y-4" onSubmit={e => { e.preventDefault(); verifyMut.mutate() }}>
          <div>
            <label className="label">Email</label>
            <input className="input" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div>
            <label className="label">Verification code</label>
            <input className="input text-center text-2xl font-mono tracking-[0.5em]" type="text" maxLength={6} placeholder="000000" value={code} onChange={e => setCode(e.target.value.replace(/\D/g, ''))} required />
          </div>
          <button type="submit" className="btn-primary w-full justify-center" disabled={verifyMut.isPending || code.length < 6}>
            {verifyMut.isPending ? 'Verifying…' : 'Verify email'}
          </button>
          <p className="text-center text-sm text-brand-muted">
            Didn't receive it? <Link to="/register" className="text-brand-blue">Re-register</Link>
          </p>
        </form>
      </div>
    </div>
  )
}
